/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import { slackNotificationTimemout } from 'src/shared/app/market/settings/marketSettings';
import Notification from 'src/shared/app/notification/component/Notification';
import messages from 'src/shared/app/notification/l10n/notificationL10n';

type Props = {
  eventName: string,
  slackChannelName: string,
  handleDismiss: () => void,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const MarketSlackNotificationDumb = (props: Props): React.Node => {
  const { eventName, slackChannelName, handleDismiss, intl } = props;

  return (
    <Notification
      timeout={slackNotificationTimemout}
      handleDismiss={handleDismiss}
    >
      {intl.formatMessage(messages.slackTopicShared, {
        eventName,
        slackChannelName,
      })}
    </Notification>
  );
};

export default compose(injectIntl)(MarketSlackNotificationDumb);
